if (!customElements.get('cart-items-summary')) {
    customElements.define(
        'cart-items-summary',
        class CartItemsSummary extends HTMLElement {
            cart = null
            shippingPrice = 0

            options = {
                currencySymbol: ''
            };

            async connectedCallback() {
                this.extractOptionsFromDataset();

                const servicesAndDeliveryUtilsService = window.serviceAndDeliveryUtils.ServicesAndDeliveryUtilsService;

                const shippingPrice = await servicesAndDeliveryUtilsService.getShippingPrice();
                this.shippingTotalPrice = shippingPrice?.rates?.total_price || 0

                this.cart = await servicesAndDeliveryUtilsService.requestCart();

                this.render();
            }

            render() {
                const productsPriceFormatted = this.formatMinorToMajorUnits(this.getNonServiceProductsPrice());
                const servicesPriceFormatted = this.formatMinorToMajorUnits(this.getServiceProductsPrice());
                const shippingPriceFormatted = this.formatMinorToMajorUnits(this.getShippingTotalPrice());
                const totalPriceFormatted = this.formatMinorToMajorUnits(this.getTotalPrice());

                const productsPriceElement = document.getElementById('products_price');
                const servicesPriceElement = document.getElementById('services_price');
                const shippingPriceElement = document.getElementById('shipping_price');
                const totalPriceElement = document.getElementById('total_price');

                productsPriceElement.textContent = `${productsPriceFormatted} ${this.options.currencySymbol}`;
                servicesPriceElement.textContent = `${servicesPriceFormatted} ${this.options.currencySymbol}`;
                shippingPriceElement.textContent = `${shippingPriceFormatted} ${this.options.currencySymbol}`;
                totalPriceElement.textContent = `${totalPriceFormatted} ${this.options.currencySymbol}`;

                setTimeout(() => {
                    productsPriceElement.classList.remove('text-waved-loading');
                    servicesPriceElement.classList.remove('text-waved-loading');
                    shippingPriceElement.classList.remove('text-waved-loading');
                    totalPriceElement.classList.remove('text-waved-loading');
                }, 700);

                const event = new CustomEvent("cart:cart-item-summary-updated", {
                    detail: {
                        totalPrice: totalPriceFormatted
                    }
                });
                document.dispatchEvent(event);
            }

            getNonServiceProductsPrice() {
                return this.cart.items.reduce((sum, cartItem) => sum + (!cartItem.properties || cartItem.properties['_is_service_product'] !== true ? cartItem.final_line_price : 0), 0);
            }

            getServiceProductsPrice() {
                return this.cart.items.reduce((sum, cartItem) => sum + (cartItem.properties && cartItem.properties['_is_service_product'] === true ? cartItem.final_line_price : 0), 0);
            }

            getTotalPrice() {
                return this.cart.total_price + this.getShippingTotalPrice();
            }

            getShippingTotalPrice() {
                return this.shippingTotalPrice;
            }

            isNumeric(value) {
                return !isNaN(value) && !isNaN(parseFloat(value));
            }

            extractOptionsFromDataset() {
                const dataset = this.dataset;

                for (const [attribute, rawValue] of Object.entries(dataset)) {
                    this.options[attribute] = rawValue;
                }
            }

            formatMinorToMajorUnits(amount) {
                let major = amount / 100;
                
                let formatted = major.toFixed(2).replace('.', ',');
            
                let parts = formatted.split(',');

                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            
                return `${parts.join(',')}`;
            }
        }
    );
}
